;(function($) {
    $('#menu-toggle').click(function () {
        $(this).toggleClass('open');
        $('#mobile-menu').toggleClass('active');
    });

})(jQuery);